import React from 'react';

import { TotemIconId } from '@meilleurtaux/mtp-uikit-core';
import { MtxIcon } from '@meilleurtaux/mtp-uikit-react';

import styles from './styles.module.css';

interface AccessCardProps {
  title: string;
  subtitle: string;
  icon: TotemIconId;
  children: React.ReactNode;
}

export const AccessCard: React.FC<AccessCardProps> = ({ title, subtitle, icon, children }) => {
  return (
    <article className={styles.card}>
      <header className={styles.cardHeader}>
        <div className={styles.iconWrapper}>
          <MtxIcon name={icon} size={24} />
        </div>
        <div className={styles.cardTitles}>
          <span className={styles.cardTitle}>{title}</span>
          <span className={styles.cardSubtitle}>{subtitle}</span>
        </div>
      </header>
      <div className={styles.cardContent}>{children}</div>
    </article>
  );
};
